import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { Link } from "react-router-dom";
import axios from "axios";
import { IoSearchOutline } from "react-icons/io5";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import AdminNav from "./AdminNav";

const DepositRequests = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [allDeposits, setAllDeposits] = useState([]);
  const [filteredDeposits, setFilteredDeposits] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const token = localStorage.getItem("admintoken");

  // Fetch deposit requests
  useEffect(() => {
    const fetchDepositData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/deposit/get-deposits`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (data?.success) {
          const sorted = (data.deposits || []).sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setAllDeposits(sorted);
          setFilteredDeposits(sorted);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchDepositData();
  }, [token]);

  // Handle Search
  useEffect(() => {
    const searchQuery = searchTerm.trim().toLowerCase();
    const filtered = searchQuery
      ? allDeposits.filter((deposit) => {
          const userName = `${deposit?.userId?.name || ""}`.toLowerCase();
          const userEmail = deposit?.userId?.email?.toLowerCase() || "";
          const depositDate = new Date(deposit.createdAt)
            .toLocaleString()
            .toLowerCase();
          const currency = deposit?.currency?.toLowerCase() || "";

          return (
            userName.includes(searchQuery) ||
            userEmail.includes(searchQuery) ||
            depositDate.includes(searchQuery) ||
            currency.includes(searchQuery)
          );
        })
      : allDeposits;

    setFilteredDeposits(filtered);
  }, [searchTerm, allDeposits]);

  const getStatusClass = (status) => {
    switch (status) {
      case "pending":
        return "kyc-pending";
      case "approved":
        return "kyc-verified";
      case "rejected":
        return "kyc-rejected";
      default:
        return "";
    }
  };

  return (
    <div className="wrapper d-flex align-items-stretch">
      {loading && <Loader />}
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="content" className="px-2">
        <button
          type="button"
          id="openSidebar"
          onClick={toggleSidebar}
          className="bars-btn"
        >
          <FaBarsStaggered />
        </button>
        <AdminNav />
        <h3 className="b-clr">Deposit Requests</h3>
        <div className="search-add-main">
          <div className="search-main">
            <input
              type="text"
              className="search-inp"
              placeholder="Search by name, email, currency, date..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="search-icon">
              <IoSearchOutline />
            </div>
          </div>
        </div>

        <div className="tbl-main">
          <table className="simple-table">
            <thead>
              <tr>
                <th>NAME</th>
                <th>EMAIL</th>
                <th>AMOUNT</th>
                <th>DATE</th>
                <th>ACTIONS</th>
                <th>STATUS</th>
              </tr>
            </thead>
            <tbody>
              {filteredDeposits.length > 0 ? (
                filteredDeposits.map((deposit) => (
                  <tr key={deposit._id}>
                    <td>{`${deposit?.userId?.name || "N/A"} `}</td>
                    <td>{deposit?.userId?.email}</td>
                    <td>{`${deposit.amount} ${deposit.currency}`}</td>
                    <td>{new Date(deposit.createdAt).toLocaleString()}</td>
                    <td>
                      <Link
                        className="btn btn-primary"
                        to={`/dashboard/admin/deposit-request-details/${deposit._id}`}
                      >
                        Details
                      </Link>
                    </td>
                    <td>
                      <span
                        className={`kyc-status ${getStatusClass(
                          deposit.status
                        )}`}
                      >
                        {deposit.status}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Deposit requests found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DepositRequests;
